
export default function About() {
  const values = [
    {
      title: "Community First",
      description: "We prioritize the collective well-being of our members and their families.",
      icon: "ri-community-line"
    },
    {
      title: "Financial Inclusion",
      description: "Making financial services accessible to everyone in our community.",
      icon: "ri-hand-heart-line"
    },
    {
      title: "Transparency",
      description: "Open and honest communication in all our financial dealings.",
      icon: "ri-eye-line"
    },
    {
      title: "Mutual Growth",
      description: "Growing together through shared resources and collective success.",
      icon: "ri-plant-line"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About Landmark Cooperative
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Landmark Cooperative is a member-focused financial cooperative dedicated to financial inclusion, 
              shared growth, and community empowerment. We provide a trusted platform for savings, access to 
              financial support, and collective opportunities that help members build long-term financial stability.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Rooted in transparency, accountability, and collaboration, Landmark Cooperative exists to help 
              individuals and families grow together—because progress is stronger when it's shared.
            </p>
            
            <div className="grid sm:grid-cols-2 gap-6">
              {values.map((value, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${value.icon} text-teal-600`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{value.title}</h4>
                    <p className="text-sm text-gray-600">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/0bb27c53207b61fb249c0e82615f07d2/42f0696cfd4cf29ae39eedb42d758566.png"
              alt="Landmark Cooperative Team"
              className="rounded-xl shadow-lg w-full h-96 object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
